import { Component } from '@angular/core';

@Component({
  selector: 'app-api-docs',
  templateUrl: './api-docs.component.html',
})
export class ApiDocsComponent {
}
